import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=8900c9be"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=8900c9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports